import { Text } from "@chakra-ui/react";
import { useWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import "../../styles/WalletConnectButton.css";
import "../../styles/WalletConnectModal.css";

export const CustomWalletMultiButton = () => {
  const { wallet, publicKey, connecting } = useWallet();

  const formatPublicKey = (key: string) => `${key.slice(0, 4)}..${key.slice(-4)}`;

  let content;

  if (connecting) {
    content = "Connecting";
  } else if (!wallet || !publicKey) {
    content = "Connect";
  } else {
    content = <Text>{formatPublicKey(publicKey.toBase58())}</Text>;
  }

  return (
    <div className="wallet-connect">
      <WalletMultiButton>{content}</WalletMultiButton>
    </div>
  );
};
